import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import UserSettingsForm from './UserSettingsForm';
import Alert from '../../../common/Alert';

const UserSettingsBlockContent = () => {
  const { user, token } = useSelector(state => state);

  const [status, setStatus] = useState({});

  return (
    <div>
      {(status.isSuccess || status.isError) && (
        <Alert message={status.message} isSuccess={status.isSuccess} isError={status.isError} />
      )}
      <div className="is-flex">
        <div className="user-image-block">
          <img src="img/icons/user-big.svg" />
          <a className="user-image-download-link disabled">Download</a>
          <p className="user-image-text mt-20px">File size max: 2Mb. Recommended foto size: 200x200 px</p>
        </div>
        <UserSettingsForm user={user} token={token} onStatusChanged={setStatus} className="is-halfwidth ml-20px" />
      </div>
    </div>
  );
};

export default UserSettingsBlockContent;
